import { render, staticRenderFns } from "./TenantpaidDetail.vue?vue&type=template&id=3c79c2d6&"
import script from "./TenantpaidDetail.vue?vue&type=script&lang=ts&"
export * from "./TenantpaidDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports